import conversationWorkflowResource from 'src/actions/conversationWorkflow/conversationWorkflow';
import messagingResource from 'src/actions/messaging/MessagingResource';
import taskRoutingResource from 'src/actions/taskRouting/taskRouting';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import voiceConfigResource from 'src/actions/voice/voiceConfigResource';
import { allSucceeded } from 'src/presentation/hooks/useResource';

export const getVoiceData = ({
  autoAccept,
  callWrapUpIntervalSecs,
  declineCallAutoReadyIntervalSecs,
  disableDeclineCall,
}) => ({
  autoAccept,
  callWrapUpIntervalSecs,
  declineCallAutoReadyIntervalSecs,
  disableDeclineCall,
});

export const getTaskData = ({ routingWindowInSeconds }) => ({
  routingWindowInSeconds,
});

export const getConversationWorkflowData = ({ requireTopics, reopenConversationWindow, sidekickAssignedAgentId }) => ({
  reopenConversationWindow,
  requireTopics,
  sidekickAssignedAgentId,
});

export const getMessageData = ({
  agentCapacity,
  agentMaxCapacity,
  assignMailToConversationAssignee,
  autoAssignMessagingSessions,
  chatSessionRejoinWindowSecs,
  closeAbandonedChatSessions,
  enableFocusMode,
  endMailSessionIntervalMins,
  endMessagingSessionIntervalMins,
  lookupBeforeRouting,
  routeNextMessagingSessionIntervalSecs,
  showPreview,
}) => ({
  agentCapacity,
  agentMaxCapacity,
  assignMailToConversationAssignee,
  autoAssignMessagingSessions,
  chatSessionRejoinWindowSecs,
  closeAbandonedChatSessions,
  enableFocusMode,
  endMailSessionIntervalMins,
  endMessagingSessionIntervalMins,
  lookupBeforeRouting,
  routeNextMessagingSessionIntervalSecs,
  showPreview,
});

export const useRoutes = () => {
  const {
    value: taskRouting,
    errors: errorsTaskRouting,
    loadingState: loadingStateTaskRouting,
  } = useDocumentResource(taskRoutingResource);
  const {
    value: conversationWorkflow,
    errors: errorsConversationWorkflow,
    loadingState: loadingStateConversationWorkflow,
  } = useDocumentResource(conversationWorkflowResource);
  const { value: messages, errors: errorsMessages, loadingState } = useDocumentResource(messagingResource);
  const {
    value: voice,
    errors: errorsVoice,
    loadingState: loadingStateVoice,
  } = useDocumentResource(voiceConfigResource);
  const allDataSucceeded = allSucceeded(
    loadingState,
    loadingStateVoice,
    loadingStateTaskRouting,
    loadingStateConversationWorkflow
  );
  const item = allDataSucceeded
    ? {
        ...messages,
        ...taskRouting,
        ...conversationWorkflow,
        callWrapUpIntervalSecs: voice.callWrapUpIntervalSecs,
        declineCallAutoReadyIntervalSecs: voice.declineCallAutoReadyIntervalSecs,
        disableDeclineCall: voice.disableDeclineCall,
        autoAccept: voice.autoAccept,
      }
    : {};
  const errors = [...errorsMessages, ...errorsTaskRouting, ...errorsVoice, ...errorsConversationWorkflow];
  return {
    item,
    isLoading: !allDataSucceeded,
    errors,
  };
};
